import type { OwaDate } from 'owa-datetime';

export default function getDueDateActionType(
    newDate: OwaDate | null | undefined,
    oldDate: OwaDate | null | undefined
) {
    if (!!newDate && oldDate == null) {
        return 'Set';
    } else if (!!newDate && !!oldDate) {
        return 'Update';
    } else if (newDate == null && !!oldDate) {
        return 'Remove';
    }

    return 'Noop';
}
